const DOWNGRADED_TO_FREE = 'Downgraded to Free';
const DEACTIVATED_ACCOUNT = 'Deactivated Account';

const subscriptionAnalyticsConstants = {
  DOWNGRADED_TO_FREE,
  DEACTIVATED_ACCOUNT,
};

export default subscriptionAnalyticsConstants;
